import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { FaviconService } from '../favicon.service';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { LoginService } from '../security/login.service';
import { RefundRequest } from '../refund-request';
import { ToastMessageService } from '../toast-message.service';
import { DecimalValidator } from '../validator/decimal-validator';
import Decimal from 'decimal.js';
import { UserForBackend } from '../user-for-backend';
import { Currency } from '../currency';
import { BookingIdListItem } from '../booking-id-list-item';
import { ApiError } from '../api-error';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-refund-request-create',
  templateUrl: './refund-request-create.component.html',
  styleUrls: ['./refund-request-create.component.css']
})
export class RefundRequestCreateComponent implements OnInit {

  currencies: Currency[] = [];
  bookingIds: BookingIdListItem[] = [];
  isBookingIdsReady: boolean = false;
  studentName: string = "";
  authorities = [
    { id: 7, name: "Alain" },
    { id: 6, name: "Véronique" }
  ];
  users: UserForBackend[] = [];
  requestForm!: FormGroup;
  sendingRequest = false;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private favicon: FaviconService,
    private loginService: LoginService,
    private router: Router,
    private toastService: ToastMessageService
  ) {
    this.loginService.activatedNavigationComponent = true;
    this.favicon.sbms();
  }

  ngOnInit() {
    forkJoin({
      bookingIdList: this.httpService.getRecentBookingIds(),
      currencies: this.httpService.getCurrencies()
    }).subscribe(({
      bookingIdList, currencies
    }) => {
      this.bookingIds = bookingIdList;
      this.isBookingIdsReady = true;
      this.currencies = currencies;
      this.requestForm = this.builder.group({
        bookingIdArray: this.builder.array([]),
        amount: [null, [Validators.required, DecimalValidator]],
        currency: this.currencies[0],
        reason: [null, Validators.required],
        iban: [null, Validators.required],
        approvedBy: null,
        bic: null,
        isApproved: false,
        accountHolderName: null,
      });
      this.bookingIdArray.push(new FormControl());
      this.checkAmountFormat();
    });
    this.httpService.getActiveUsers().subscribe(res => {
      this.users = res;
    });
  }

  get bookingIdArray(): FormArray {
    return this.requestForm.get("bookingIdArray") as FormArray;
  }

  addBookingIdControl() {
    this.bookingIdArray.push(new FormControl());
  }

  deleteBookingIdControl(index: number) {
    this.bookingIdArray.removeAt(index);
    this.onBookingIdChange();
  }

  checkAmountFormat() {
    this.requestForm.get("amount")!.valueChanges.subscribe(val => {
      let index = val.indexOf(",");
      if (index != -1) {
        let newValue = val.substring(0, index) + "." + val.substring(index + 1, val.length);
        this.requestForm.get("amount")!.setValue(newValue.replace(/[^0-9\.]/g, ""));
      } else {
        let newValue = val.replace(/[^0-9\.]/g, "");
        if (newValue != val) {
          this.requestForm.get("amount")!.setValue(newValue);
        }
      }
    });
  }

  sendForm() {
    if (this.requestForm.invalid) {
      this.toastService.addError("Error", "Please complete the form.");
      return;
    }
    if (this.bookingIdArray.length == 0) {
      this.toastService.addError("Error", "You need to select booking id");
      return;
    }
    this.sendingRequest = true;
    let bookingIdListItems: BookingIdListItem[] = [];

    for (let bookingIdCtr of this.bookingIdArray.controls) {
      bookingIdListItems.push(bookingIdCtr.value);
    }
    let request = new RefundRequest(
      bookingIdListItems,
      this.requestForm.value.requestedBy,
      new Decimal(this.requestForm.value.amount),
      this.requestForm.value.currency,
      this.requestForm.value.iban,
      false,
      this.requestForm.value.approvedBy,
      this.requestForm.value.reason,
      this.requestForm.value.bic,
      this.requestForm.value.isApproved,
      this.requestForm.value.accountHolderName,
      this.requestForm.value.studentFirstName,
      this.requestForm.value.studentLastName
    );

    this.httpService.postRefundRequest(request).subscribe(() => {
      this.toastService.addSuccess("Success", "success");
      this.clearForm();
      this.sendingRequest = false;
    }, error => {
      this.toastService.addError("Error", error.message);
      this.sendingRequest = false;
    });
  }

  onBookingIdChange() {
    let bookingIds: number[] = [];
    for (let control of this.bookingIdArray.controls) {
      if (control.value) {
        bookingIds.push(control.value.bookingId);
      }
    }
    if (bookingIds.length == 0) {
      this.studentName = "";
    } else {
      this.httpService.getStudentNameByBookingIdList(bookingIds).subscribe(res => {
        this.studentName = res;
      }, error => this.toastService.addApiError(new ApiError(error)));
    }
  }

  clearForm() {
    this.requestForm = this.builder.group({
      bookingIdArray: this.builder.array([]),
      amount: [null, Validators.required],
      currency: this.currencies[0],
      requestedBy: null,
      reason: null,
      iban: null,
      approvedBy: null,
      bic: null,
      isApproved: false,
      accountHolderName: null
    });
  }

}